export const pokemonData = [
  {
    id: 1,
    name: "Bulbasaur",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/1.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/1.png",
    stats: {
      hp: 45,
      attack: 49,
      defense: 49,
      "special-attack": 65,
      "special-defense": 65,
      speed: 45
    },
    height: 0.7,
    weight: 6.9,
    abilities: ["Overgrow", "Chlorophyll"],
    description: "There is a plant seed on its back right from the day this Pokémon is born. The seed slowly grows larger.",
    legendary: false,
    evolutions: [
      { name: "Bulbasaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/1.png" },
      { name: "Ivysaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/2.png", level: 16 },
      { name: "Venusaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/3.png", level: 32 }
    ],
    typeWeaknesses: ["Fire", "Psychic", "Flying", "Ice"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "Bulbasaur is the first Pokémon in the National Pokédex.",
      "It can survive for days without eating because it stores energy in its bulb."
    ]
  },
  {
    id: 2,
    name: "Ivysaur",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/2.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/2.png",
    stats: {
      hp: 60,
      attack: 62,
      defense: 63,
      "special-attack": 80,
      "special-defense": 80,
      speed: 60
    },
    height: 1.0,
    weight: 13.0,
    abilities: ["Overgrow", "Chlorophyll"],
    description: "When the bulb on its back grows large, it appears to lose the ability to stand on its hind legs.",
    legendary: false,
    evolutions: [
      { name: "Bulbasaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/1.png" },
      { name: "Ivysaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/2.png", level: 16 },
      { name: "Venusaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/3.png", level: 32 }
    ],
    typeWeaknesses: ["Fire", "Psychic", "Flying", "Ice"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "The bud on Ivysaur's back grows by drawing energy from its body.",
      "Its bud gives off a sweet aroma when it is ready to bloom."
    ]
  },
  {
    id: 3,
    name: "Venusaur",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/3.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/3.png",
    stats: {
      hp: 80,
      attack: 82,
      defense: 83,
      "special-attack": 100,
      "special-defense": 100,
      speed: 80
    },
    height: 2.0,
    weight: 100.0,
    abilities: ["Overgrow", "Chlorophyll"],
    description: "Its plant blooms when it is absorbing solar energy. It stays on the move to seek sunlight.",
    legendary: false,
    evolutions: [
      { name: "Bulbasaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/1.png" },
      { name: "Ivysaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/2.png", level: 16 },
      { name: "Venusaur", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/3.png", level: 32 }
    ],
    typeWeaknesses: ["Fire", "Psychic", "Flying", "Ice"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "Venusaur's flower is said to take on vivid colors if it gets plenty of nutrition and sunlight.",
      "The flower on its back can release a soothing scent that calms aggressive feelings."
    ]
  },
  {
    id: 4,
    name: "Charmander",
    types: ["Fire"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/4.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/4.png",
    stats: {
      hp: 39,
      attack: 52,
      defense: 43,
      "special-attack": 60,
      "special-defense": 50,
      speed: 65
    },
    height: 0.6,
    weight: 8.5,
    abilities: ["Blaze", "Solar Power"],
    description: "The flame on its tail indicates Charmander's life force. If it is healthy, the flame burns brightly.",
    legendary: false,
    evolutions: [
      { name: "Charmander", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/4.png" },
      { name: "Charmeleon", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/5.png", level: 16 },
      { name: "Charizard", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/6.png", level: 36 }
    ],
    typeWeaknesses: ["Water", "Ground", "Rock"],
    typeResistances: ["Fire", "Grass", "Ice", "Bug", "Steel", "Fairy"],
    trivia: [
      "If Charmander's flame goes out, it is said that the Pokémon's life comes to an end.",
      "The flame on its tail burns hotter when it gets angry or excited."
    ]
  },
  {
    id: 5,
    name: "Charmeleon",
    types: ["Fire"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/5.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/5.png",
    stats: {
      hp: 58,
      attack: 64,
      defense: 58,
      "special-attack": 80,
      "special-defense": 65,
      speed: 80
    },
    height: 1.1,
    weight: 19.0,
    abilities: ["Blaze", "Solar Power"],
    description: "When it swings its burning tail, it elevates the temperature to unbearably high levels.",
    legendary: false,
    evolutions: [
      { name: "Charmander", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/4.png" },
      { name: "Charmeleon", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/5.png", level: 16 },
      { name: "Charizard", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/6.png", level: 36 }
    ],
    typeWeaknesses: ["Water", "Ground", "Rock"],
    typeResistances: ["Fire", "Grass", "Ice", "Bug", "Steel", "Fairy"],
    trivia: [
      "Charmeleon has a vicious nature and will constantly seek out opponents to battle.",
      "If it becomes agitated during battle, it spouts intense flames, incinerating its surroundings."
    ]
  },
  {
    id: 6,
    name: "Charizard",
    types: ["Fire", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/6.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/6.png",
    stats: {
      hp: 78,
      attack: 84,
      defense: 78,
      "special-attack": 109,
      "special-defense": 85,
      speed: 100
    },
    height: 1.7,
    weight: 90.5,
    abilities: ["Blaze", "Solar Power"],
    description: "It spits fire that is hot enough to melt boulders. It may cause forest fires by blowing flames.",
    legendary: false,
    evolutions: [
      { name: "Charmander", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/4.png" },
      { name: "Charmeleon", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/5.png", level: 16 },
      { name: "Charizard", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/6.png", level: 36 }
    ],
    typeWeaknesses: ["Water", "Electric", "Rock (4×)"],
    typeResistances: ["Fighting", "Bug", "Fire", "Grass", "Fairy", "Ground (immune)"],
    trivia: [
      "Charizard flies around the sky in search of powerful opponents.",
      "Its wings can carry this Pokémon close to an altitude of 4,600 feet."
    ]
  },
  {
    id: 7,
    name: "Squirtle",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/7.png",
    stats: {
      hp: 44,
      attack: 48,
      defense: 65,
      "special-attack": 50,
      "special-defense": 64,
      speed: 43
    },
    height: 0.5,
    weight: 9.0,
    abilities: ["Torrent", "Rain Dish"],
    description: "When it retracts its long neck into its shell, it squirts out water with vigorous force.",
    legendary: false,
    evolutions: [
      { name: "Squirtle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png" },
      { name: "Wartortle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/8.png", level: 16 },
      { name: "Blastoise", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/9.png", level: 36 }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Squirtle's shell is not just for protection, but also for minimizing water resistance when swimming.",
      "When it feels threatened, it withdraws into its shell and sprays water from its mouth."
    ]
  },
  {
    id: 8,
    name: "Wartortle",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/8.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/8.png",
    stats: {
      hp: 59,
      attack: 63,
      defense: 80,
      "special-attack": 65,
      "special-defense": 80,
      speed: 58
    },
    height: 1.0,
    weight: 22.5,
    abilities: ["Torrent", "Rain Dish"],
    description: "It is recognized as a symbol of longevity. If its shell has algae on it, that Wartortle is very old.",
    legendary: false,
    evolutions: [
      { name: "Squirtle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png" },
      { name: "Wartortle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/8.png", level: 16 },
      { name: "Blastoise", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/9.png", level: 36 }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Its tail is large and covered with rich, thick fur that deepens in color with age.",
      "The scratches on its shell are evidence of its toughness as a battler."
    ]
  },
  {
    id: 9,
    name: "Blastoise",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/9.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/9.png",
    stats: {
      hp: 79,
      attack: 83,
      defense: 100,
      "special-attack": 85,
      "special-defense": 105,
      speed: 78
    },
    height: 1.6,
    weight: 85.5,
    abilities: ["Torrent", "Rain Dish"],
    description: "It crushes its foe under its heavy body to cause fainting. In a pinch, it will withdraw inside its shell.",
    legendary: false,
    evolutions: [
      { name: "Squirtle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png" },
      { name: "Wartortle", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/8.png", level: 16 },
      { name: "Blastoise", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/9.png", level: 36 }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "The water jets from Blastoise's cannons can punch through thick steel.",
      "It deliberately makes itself heavy to withstand these powerful water jets."
    ]
  },
  {
    id: 16,
    name: "Pidgey",
    types: ["Normal", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/16.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/16.png",
    stats: {
      hp: 40,
      attack: 45,
      defense: 40,
      "special-attack": 35,
      "special-defense": 35,
      speed: 56
    },
    height: 0.3,
    weight: 1.8,
    abilities: ["Keen Eye", "Tangled Feet", "Big Pecks"],
    description: "Very docile. If attacked, it will often kick up sand to protect itself rather than fight back.",
    legendary: false,
    evolutions: [
      { name: "Pidgey", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/16.png" },
      { name: "Pidgeotto", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/17.png", level: 18 },
      { name: "Pidgeot", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/18.png", level: 36 }
    ],
    typeWeaknesses: ["Electric", "Ice", "Rock"],
    typeResistances: ["Ground (immune)", "Grass", "Bug", "Ghost"],
    trivia: [
      "Pidgey is one of the most commonly seen Pokémon in the wild.",
      "It can create powerful gusts of wind by flapping its wings rapidly."
    ]
  },
  {
    id: 18,
    name: "Pidgeot",
    types: ["Normal", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/18.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/18.png",
    stats: {
      hp: 83,
      attack: 80,
      defense: 75,
      "special-attack": 70,
      "special-defense": 70,
      speed: 101
    },
    height: 1.5,
    weight: 39.5,
    abilities: ["Keen Eye", "Tangled Feet", "Big Pecks"],
    description: "This Pokémon flies at Mach 2 speed, seeking prey. Its large talons are feared as wicked weapons.",
    legendary: false,
    evolutions: [
      { name: "Pidgey", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/16.png" },
      { name: "Pidgeotto", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/17.png", level: 18 },
      { name: "Pidgeot", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/18.png", level: 36 }
    ],
    typeWeaknesses: ["Electric", "Ice", "Rock"],
    typeResistances: ["Ground (immune)", "Grass", "Bug", "Ghost"],
    trivia: [
      "Pidgeot can fly at speeds of up to Mach 2.",
      "Its plumage is often used for decorative purposes due to its beauty."
    ]
  },
  {
    id: 23,
    name: "Ekans",
    types: ["Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/23.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/23.png",
    stats: {
      hp: 35,
      attack: 60,
      defense: 44,
      "special-attack": 40,
      "special-defense": 54,
      speed: 55
    },
    height: 2.0,
    weight: 6.9,
    abilities: ["Intimidate", "Shed Skin", "Unnerve"],
    description: "The older it gets, the longer it grows. At night, it wraps its long body around tree branches to rest.",
    legendary: false,
    evolutions: [
      { name: "Ekans", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/23.png" },
      { name: "Arbok", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/24.png", level: 22 }
    ],
    typeWeaknesses: ["Ground", "Psychic"],
    typeResistances: ["Grass", "Fighting", "Poison", "Bug", "Fairy"],
    trivia: [
      "Ekans is 'snake' spelled backwards.",
      "It can dislocate its jaw to swallow prey whole."
    ]
  },
  {
    id: 24,
    name: "Arbok",
    types: ["Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/24.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/24.png",
    stats: {
      hp: 60,
      attack: 95,
      defense: 69,
      "special-attack": 65,
      "special-defense": 79,
      speed: 80
    },
    height: 3.5,
    weight: 65.0,
    abilities: ["Intimidate", "Shed Skin", "Unnerve"],
    description: "The pattern on its belly appears to be a frightening face. Weak foes will flee just at the sight of the pattern.",
    legendary: false,
    evolutions: [
      { name: "Ekans", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/23.png" },
      { name: "Arbok", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/24.png", level: 22 }
    ],
    typeWeaknesses: ["Ground", "Psychic"],
    typeResistances: ["Grass", "Fighting", "Poison", "Bug", "Fairy"],
    trivia: [
      "Arbok is 'kobra' (cobra) spelled backwards.",
      "The pattern on its hood varies by region, with over 20 different known patterns."
    ]
  },
  {
    id: 25,
    name: "Pikachu",
    types: ["Electric"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/25.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/25.png",
    stats: {
      hp: 35,
      attack: 55,
      defense: 40,
      "special-attack": 50,
      "special-defense": 50,
      speed: 90
    },
    height: 0.4,
    weight: 6.0,
    abilities: ["Static", "Lightning Rod"],
    description: "When it is angered, it immediately discharges the energy stored in the pouches in its cheeks.",
    legendary: false,
    evolutions: [
      { name: "Pichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/172.png" },
      { name: "Pikachu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/25.png", level: "Happiness" },
      { name: "Raichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/26.png", level: "Thunder Stone" }
    ],
    typeWeaknesses: ["Ground"],
    typeResistances: ["Flying", "Steel", "Electric"],
    trivia: [
      "Pikachu is the mascot of the Pokémon franchise.",
      "Its name comes from the Japanese onomatopoeia for sparkling, 'pikapika', and the sound of squeaking, 'chu'."
    ]
  },
  {
    id: 26,
    name: "Raichu",
    types: ["Electric"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/26.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/26.png",
    stats: {
      hp: 60,
      attack: 90,
      defense: 55,
      "special-attack": 90,
      "special-defense": 80,
      speed: 110
    },
    height: 0.8,
    weight: 30.0,
    abilities: ["Static", "Lightning Rod"],
    description: "Its long tail serves as a ground to protect itself from its own high-voltage power.",
    legendary: false,
    evolutions: [
      { name: "Pichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/172.png" },
      { name: "Pikachu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/25.png", level: "Happiness" },
      { name: "Raichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/26.png", level: "Thunder Stone" }
    ],
    typeWeaknesses: ["Ground"],
    typeResistances: ["Flying", "Steel", "Electric"],
    trivia: [
      "Raichu can knock out even an Indian elephant with its electrical charge.",
      "It has a regional variant in the Alola region that is Electric/Psychic type."
    ]
  },
  {
    id: 53,
    name: "Persian",
    types: ["Normal"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/53.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/53.png",
    stats: {
      hp: 65,
      attack: 70,
      defense: 60,
      "special-attack": 65,
      "special-defense": 65,
      speed: 115
    },
    height: 1.0,
    weight: 32.0,
    abilities: ["Limber", "Technician", "Unnerve"],
    description: "Although its fur has many admirers, it is tough to raise as a pet because of its fickle meanness.",
    legendary: false,
    evolutions: [
      { name: "Meowth", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/52.png" },
      { name: "Persian", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/53.png", level: 28 }
    ],
    typeWeaknesses: ["Fighting"],
    typeResistances: ["Ghost (immune)"],
    trivia: [
      "The gem on Persian's forehead is said to glow and shine with the colors of the rainbow.",
      "It has a regional variant in the Alola region that is Dark type."
    ]
  },
  {
    id: 60,
    name: "Poliwag",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/60.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/60.png",
    stats: {
      hp: 40,
      attack: 50,
      defense: 40,
      "special-attack": 40,
      "special-defense": 40,
      speed: 90
    },
    height: 0.6,
    weight: 12.4,
    abilities: ["Water Absorb", "Damp", "Swift Swim"],
    description: "Its skin is so thin, its internal organs are visible. It has trouble walking on its newly grown feet.",
    legendary: false,
    evolutions: [
      { name: "Poliwag", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/60.png" },
      { name: "Poliwhirl", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/61.png", level: 25 },
      { name: "Poliwrath", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/62.png", level: "Water Stone" },
      { name: "Politoed", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/186.png", level: "Trade with King's Rock" }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "The spiral pattern on its belly is actually its internal organs showing through its thin skin.",
      "It is said that the direction of the spiral differs by area."
    ]
  },
  {
    id: 61,
    name: "Poliwhirl",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/61.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/61.png",
    stats: {
      hp: 65,
      attack: 65,
      defense: 65,
      "special-attack": 50,
      "special-defense": 50,
      speed: 90
    },
    height: 1.0,
    weight: 20.0,
    abilities: ["Water Absorb", "Damp", "Swift Swim"],
    description: "The spiral pattern on its belly subtly undulates. Staring at it too long will cause dizziness.",
    legendary: false,
    evolutions: [
      { name: "Poliwag", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/60.png" },
      { name: "Poliwhirl", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/61.png", level: 25 },
      { name: "Poliwrath", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/62.png", level: "Water Stone" },
      { name: "Politoed", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/186.png", level: "Trade with King's Rock" }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "The swirl on Poliwhirl's belly is actually a part of its intestines visible through its skin.",
      "This spiral pattern can induce drowsiness if stared at."
    ]
  },
  {
    id: 62,
    name: "Poliwrath",
    types: ["Water", "Fighting"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/62.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/62.png",
    stats: {
      hp: 90,
      attack: 95,
      defense: 95,
      "special-attack": 70,
      "special-defense": 90,
      speed: 70
    },
    height: 1.3,
    weight: 54.0,
    abilities: ["Water Absorb", "Damp", "Swift Swim"],
    description: "An adept swimmer, it knows the front crawl, butterfly, and more. It is faster than the best human swimmers.",
    legendary: false,
    evolutions: [
      { name: "Poliwag", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/60.png" },
      { name: "Poliwhirl", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/61.png", level: 25 },
      { name: "Poliwrath", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/62.png", level: "Water Stone" }
    ],
    typeWeaknesses: ["Electric", "Grass", "Flying", "Psychic", "Fairy"],
    typeResistances: ["Rock", "Bug", "Dark", "Ice", "Fire", "Water", "Steel"],
    trivia: [
      "Poliwrath's highly developed muscles never tire, no matter how much it exercises.",
      "It can swim back and forth across the Pacific Ocean without rest."
    ]
  },
  {
    id: 69,
    name: "Bellsprout",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/69.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/69.png",
    stats: {
      hp: 50,
      attack: 75,
      defense: 35,
      "special-attack": 70,
      "special-defense": 30,
      speed: 40
    },
    height: 0.7,
    weight: 4.0,
    abilities: ["Chlorophyll", "Gluttony"],
    description: "A carnivorous Pokémon that traps and eats bugs. It appears to use its root feet to soak up needed moisture.",
    legendary: false,
    evolutions: [
      { name: "Bellsprout", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/69.png" },
      { name: "Weepinbell", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/70.png", level: 21 },
      { name: "Victreebel", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/71.png", level: "Leaf Stone" }
    ],
    typeWeaknesses: ["Fire", "Flying", "Ice", "Psychic"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "Bellsprout's thin stem sways to dodge attacks.",
      "It can digest almost anything with the acid inside its mouth."
    ]
  },
  {
    id: 70,
    name: "Weepinbell",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/70.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/70.png",
    stats: {
      hp: 65,
      attack: 90,
      defense: 50,
      "special-attack": 85,
      "special-defense": 45,
      speed: 55
    },
    height: 1.0,
    weight: 6.4,
    abilities: ["Chlorophyll", "Gluttony"],
    description: "When hungry, it swallows anything that moves. Its hapless prey is dissolved by strong acids.",
    legendary: false,
    evolutions: [
      { name: "Bellsprout", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/69.png" },
      { name: "Weepinbell", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/70.png", level: 21 },
      { name: "Victreebel", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/71.png", level: "Leaf Stone" }
    ],
    typeWeaknesses: ["Fire", "Flying", "Ice", "Psychic"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "Weepinbell spits out poisonous powder to immobilize its prey before melting it with acid.",
      "It can be found hanging from tree branches, waiting for prey to pass by."
    ]
  },
  {
    id: 71,
    name: "Victreebel",
    types: ["Grass", "Poison"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/71.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/71.png",
    stats: {
      hp: 80,
      attack: 105,
      defense: 65,
      "special-attack": 100,
      "special-defense": 70,
      speed: 70
    },
    height: 1.7,
    weight: 15.5,
    abilities: ["Chlorophyll", "Gluttony"],
    description: "Lures prey with the sweet aroma of honey. Swallowed whole, the prey is dissolved in a day, bones and all.",
    legendary: false,
    evolutions: [
      { name: "Bellsprout", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/69.png" },
      { name: "Weepinbell", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/70.png", level: 21 },
      { name: "Victreebel", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/71.png", level: "Leaf Stone" }
    ],
    typeWeaknesses: ["Fire", "Flying", "Ice", "Psychic"],
    typeResistances: ["Water", "Electric", "Grass", "Fighting"],
    trivia: [
      "The long vine extending from its head is used to catch prey.",
      "Once caught, the prey is dissolved by powerful acids inside its large mouth."
    ]
  },
  {
    id: 86,
    name: "Seel",
    types: ["Water"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/86.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/86.png",
    stats: {
      hp: 65,
      attack: 45,
      defense: 55,
      "special-attack": 45,
      "special-defense": 70,
      speed: 45
    },
    height: 1.1,
    weight: 90.0,
    abilities: ["Thick Fat", "Hydration", "Ice Body"],
    description: "The protruding horn on its head is very hard. It is used for bashing through thick ice.",
    legendary: false,
    evolutions: [
      { name: "Seel", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/86.png" },
      { name: "Dewgong", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/87.png", level: 34 }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Seel hunts for prey in frigid waters beneath ice floes.",
      "Its thick layer of blubber makes it resistant to cold."
    ]
  },
  {
    id: 96,
    name: "Drowzee",
    types: ["Psychic"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/96.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/96.png",
    stats: {
      hp: 60,
      attack: 48,
      defense: 45,
      "special-attack": 43,
      "special-defense": 90,
      speed: 42
    },
    height: 1.0,
    weight: 32.4,
    abilities: ["Insomnia", "Forewarn", "Inner Focus"],
    description: "If you sleep by it all the time, it will sometimes show you dreams it has eaten in the past.",
    legendary: false,
    evolutions: [
      { name: "Drowzee", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/96.png" },
      { name: "Hypno", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/97.png", level: 26 }
    ],
    typeWeaknesses: ["Bug", "Ghost", "Dark"],
    typeResistances: ["Fighting", "Psychic"],
    trivia: [
      "Drowzee can eat dreams and will get sick if it eats bad dreams.",
      "It remembers every dream it eats and can show these dreams to others."
    ]
  },
  {
    id: 144,
    name: "Articuno",
    types: ["Ice", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/144.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/144.png",
    stats: {
      hp: 90,
      attack: 85,
      defense: 100,
      "special-attack": 95,
      "special-defense": 125,
      speed: 85
    },
    height: 1.7,
    weight: 55.4,
    abilities: ["Pressure", "Snow Cloak"],
    description: "A legendary bird Pokémon that is said to appear to doomed people who are lost in icy mountains.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Steel", "Fire", "Electric", "Rock (4×)"],
    typeResistances: ["Grass", "Ground", "Bug"],
    trivia: [
      "Articuno is one of the three legendary birds of Kanto.",
      "It's said to appear before travelers lost in icy regions, giving them hope."
    ]
  },
  {
    id: 145,
    name: "Zapdos",
    types: ["Electric", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/145.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/145.png",
    stats: {
      hp: 90,
      attack: 90,
      defense: 85,
      "special-attack": 125,
      "special-defense": 90,
      speed: 100
    },
    height: 1.6,
    weight: 52.6,
    abilities: ["Pressure", "Static"],
    description: "A legendary bird Pokémon that is said to appear from clouds while dropping enormous lightning bolts.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ice", "Rock (4×)"],
    typeResistances: ["Fighting", "Flying", "Bug", "Grass", "Ground (immune)"],
    trivia: [
      "Zapdos is one of the three legendary birds of Kanto.",
      "It's said to live in thunderclouds and gain power from lightning strikes."
    ]
  },
  {
    id: 146,
    name: "Moltres",
    types: ["Fire", "Flying"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/146.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/146.png",
    stats: {
      hp: 90,
      attack: 100,
      defense: 90,
      "special-attack": 125,
      "special-defense": 85,
      speed: 90
    },
    height: 2.0,
    weight: 60.0,
    abilities: ["Pressure", "Flame Body"],
    description: "A legendary bird Pokémon that is said to bring early spring to the wintry lands it visits.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Electric", "Rock (4×)"],
    typeResistances: ["Fighting", "Bug", "Fire", "Grass", "Fairy", "Ground"],
    trivia: [
      "Moltres is one of the three legendary birds of Kanto.",
      "It's said that its appearance signals the coming of spring."
    ]
  },
  {
    id: 150,
    name: "Mewtwo",
    types: ["Psychic"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/150.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/150.png",
    stats: {
      hp: 106,
      attack: 110,
      defense: 90,
      "special-attack": 154,
      "special-defense": 90,
      speed: 130
    },
    height: 2.0,
    weight: 122.0,
    abilities: ["Pressure", "Unnerve"],
    description: "It was created by a scientist after years of horrific gene-splicing and DNA-engineering experiments.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Bug", "Ghost", "Dark"],
    typeResistances: ["Fighting", "Psychic"],
    trivia: [
      "Mewtwo is a genetically engineered Pokémon created from the DNA of Mew.",
      "It is said to have the most savage heart among all Pokémon."
    ]
  },
  {
    id: 151,
    name: "Mew",
    types: ["Psychic"],
    region: "Kanto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/151.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/151.png",
    stats: {
      hp: 100,
      attack: 100,
      defense: 100,
      "special-attack": 100,
      "special-defense": 100,
      speed: 100
    },
    height: 0.4,
    weight: 4.0,
    abilities: ["Synchronize"],
    description: "When viewed through a microscope, this Pokémon's short, fine, delicate hair can be seen.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Bug", "Ghost", "Dark"],
    typeResistances: ["Fighting", "Psychic"],
    trivia: [
      "Mew is said to possess the genetic composition of all Pokémon.",
      "It is capable of learning every move that can be taught to Pokémon."
    ]
  },
  {
    id: 172,
    name: "Pichu",
    types: ["Electric"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/172.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/172.png",
    stats: {
      hp: 20,
      attack: 40,
      defense: 15,
      "special-attack": 35,
      "special-defense": 35,
      speed: 60
    },
    height: 0.3,
    weight: 2.0,
    abilities: ["Static", "Lightning Rod"],
    description: "It is not yet skilled at storing electricity. It may send out a jolt if amused or startled.",
    legendary: false,
    evolutions: [
      { name: "Pichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/172.png" },
      { name: "Pikachu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/25.png", level: "Happiness" },
      { name: "Raichu", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/26.png", level: "Thunder Stone" }
    ],
    typeWeaknesses: ["Ground"],
    typeResistances: ["Flying", "Steel", "Electric"],
    trivia: [
      "Pichu often shock themselves when experiencing intense emotions.",
      "It plays with other Pichu by touching tails and releasing small electric shocks."
    ]
  },
  {
    id: 186,
    name: "Politoed",
    types: ["Water"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/186.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/186.png",
    stats: {
      hp: 90,
      attack: 75,
      defense: 75,
      "special-attack": 90,
      "special-defense": 100,
      speed: 70
    },
    height: 1.1,
    weight: 33.9,
    abilities: ["Water Absorb", "Damp", "Drizzle"],
    description: "The curled hair on Politoed's head is proof of its status as a king. It is said that the longer and more curled the hair, the more respect it earns from its peers.",
    legendary: false,
    evolutions: [
      { name: "Poliwag", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/60.png" },
      { name: "Poliwhirl", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/61.png", level: 25 },
      { name: "Politoed", image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/186.png", level: "Trade with King's Rock" }
    ],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Politoed's cries sound like bellowing, and they gather from far and wide to form choruses.",
      "The Politoed with the biggest, curliest hair is the leader of the group."
    ]
  },
  {
    id: 243,
    name: "Raikou",
    types: ["Electric"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/243.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/243.png",
    stats: {
      hp: 90,
      attack: 85,
      defense: 75,
      "special-attack": 115,
      "special-defense": 100,
      speed: 115
    },
    height: 1.9,
    weight: 178.0,
    abilities: ["Pressure", "Inner Focus"],
    description: "Raikou embodies the speed of lightning. The roars of this Pokémon send shock waves shuddering through the air and shake the ground as if lightning bolts had come crashing down.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ground"],
    typeResistances: ["Flying", "Steel", "Electric"],
    trivia: [
      "Raikou is one of the three legendary beasts of Johto.",
      "It's said to have been born when the Brass Tower in Ecruteak City burned down."
    ]
  },
  {
    id: 244,
    name: "Entei",
    types: ["Fire"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/244.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/244.png",
    stats: {
      hp: 115,
      attack: 115,
      defense: 85,
      "special-attack": 90,
      "special-defense": 75,
      speed: 100
    },
    height: 2.1,
    weight: 198.0,
    abilities: ["Pressure", "Inner Focus"],
    description: "Entei embodies the passion of magma. This Pokémon is thought to have been born in the eruption of a volcano. It sends up massive bursts of fire that utterly consume all that they touch.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Ground", "Rock"],
    typeResistances: ["Fire", "Grass", "Ice", "Bug", "Steel", "Fairy"],
    trivia: [
      "Entei is one of the three legendary beasts of Johto.",
      "It's said to have been born when the Brass Tower in Ecruteak City burned down."
    ]
  },
  {
    id: 245,
    name: "Suicune",
    types: ["Water"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/245.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/245.png",
    stats: {
      hp: 100,
      attack: 75,
      defense: 115,
      "special-attack": 90,
      "special-defense": 115,
      speed: 85
    },
    height: 2.0,
    weight: 187.0,
    abilities: ["Pressure", "Inner Focus"],
    description: "Suicune embodies the compassion of a pure spring of water. It runs across the land with gracefulness. This Pokémon has the power to purify dirty water.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Suicune is one of the three legendary beasts of Johto.",
      "It's said to have been born when the Brass Tower in Ecruteak City burned down."
    ]
  },
  {
    id: 250,
    name: "Ho-Oh",
    types: ["Fire", "Flying"],
    region: "Johto",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/250.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/250.png",
    stats: {
      hp: 106,
      attack: 130,
      defense: 90,
      "special-attack": 110,
      "special-defense": 154,
      speed: 90
    },
    height: 3.8,
    weight: 199.0,
    abilities: ["Pressure", "Regenerator"],
    description: "Ho-Oh's feathers glow in seven colors depending on the angle at which they are struck by light. These feathers are said to bring happiness to the bearers. This Pokémon is said to live at the foot of a rainbow.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Electric", "Rock (4×)"],
    typeResistances: ["Fighting", "Bug", "Fire", "Grass", "Fairy", "Ground"],
    trivia: [
      "Ho-Oh is said to have revived Raikou, Entei, and Suicune after they perished in a fire.",
      "Its feathers are said to glow with the seven colors of the rainbow."
    ]
  },
  {
    id: 377,
    name: "Regirock",
    types: ["Rock"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/377.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/377.png",
    stats: {
      hp: 80,
      attack: 100,
      defense: 200,
      "special-attack": 50,
      "special-defense": 100,
      speed: 50
    },
    height: 1.7,
    weight: 230.0,
    abilities: ["Clear Body", "Sturdy"],
    description: "Regirock was sealed away by people long ago. If this Pokémon's body is damaged in battle, it is said to seek out suitable rocks on its own to repair itself.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Grass", "Fighting", "Ground", "Steel"],
    typeResistances: ["Normal", "Flying", "Poison", "Fire"],
    trivia: [
      "Regirock is one of the three legendary golems of Hoenn.",
      "Its body is entirely made of rock, with no sign of a core or brain."
    ]
  },
  {
    id: 378,
    name: "Regice",
    types: ["Ice"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/378.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/378.png",
    stats: {
      hp: 80,
      attack: 50,
      defense: 100,
      "special-attack": 100,
      "special-defense": 200,
      speed: 50
    },
    height: 1.8,
    weight: 175.0,
    abilities: ["Clear Body", "Ice Body"],
    description: "Regice's body was made during an ice age. The deep-frozen body can't be melted, even by fire. This Pokémon controls frigid air of -328 degrees Fahrenheit.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fire", "Fighting", "Rock", "Steel"],
    typeResistances: ["Ice"],
    trivia: [
      "Regice is one of the three legendary golems of Hoenn.",
      "Its body is made of ice that won't melt even at magma-hot temperatures."
    ]
  },
  {
    id: 379,
    name: "Registeel",
    types: ["Steel"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/379.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/379.png",
    stats: {
      hp: 80,
      attack: 75,
      defense: 150,
      "special-attack": 75,
      "special-defense": 150,
      speed: 50
    },
    height: 1.9,
    weight: 205.0,
    abilities: ["Clear Body", "Light Metal"],
    description: "Registeel has a body that is harder than any kind of metal. Its body is apparently hollow. No one has any idea what this Pokémon eats.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fire", "Fighting", "Ground"],
    typeResistances: ["Normal", "Flying", "Rock", "Bug", "Steel", "Grass", "Psychic", "Ice", "Dragon", "Fairy", "Poison (immune)"],
    trivia: [
      "Registeel is one of the three legendary golems of Hoenn.",
      "Its body is said to be hollow despite being harder than any metal."
    ]
  },
  {
    id: 380,
    name: "Latias",
    types: ["Dragon", "Psychic"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/380.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/380.png",
    stats: {
      hp: 80,
      attack: 80,
      defense: 90,
      "special-attack": 110,
      "special-defense": 130,
      speed: 110
    },
    height: 1.4,
    weight: 40.0,
    abilities: ["Levitate"],
    description: "Latias is highly sensitive to the emotions of people. If it senses any hostility, this Pokémon ruffles the feathers all over its body and cries shrilly to intimidate the foe.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ice", "Bug", "Ghost", "Dragon", "Dark", "Fairy"],
    typeResistances: ["Fighting", "Fire", "Water", "Grass", "Electric", "Psychic"],
    trivia: [
      "Latias is the female counterpart to Latios.",
      "It can use its down feathers to refract light, allowing it to become invisible."
    ]
  },
  {
    id: 381,
    name: "Latios",
    types: ["Dragon", "Psychic"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/381.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/381.png",
    stats: {
      hp: 80,
      attack: 90,
      defense: 80,
      "special-attack": 130,
      "special-defense": 110,
      speed: 110
    },
    height: 2.0,
    weight: 60.0,
    abilities: ["Levitate"],
    description: "Latios has the ability to make others see an image of what it has seen or imagines in its head. This Pokémon is intelligent and understands human speech.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ice", "Bug", "Ghost", "Dragon", "Dark", "Fairy"],
    typeResistances: ["Fighting", "Fire", "Water", "Grass", "Electric", "Psychic"],
    trivia: [
      "Latios is the male counterpart to Latias.",
      "It can fold in its arms to fly faster, reaching speeds of up to 750 mph."
    ]
  },
  {
    id: 382,
    name: "Kyogre",
    types: ["Water"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/382.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/382.png",
    stats: {
      hp: 100,
      attack: 100,
      defense: 90,
      "special-attack": 150,
      "special-defense": 140,
      speed: 90
    },
    height: 4.5,
    weight: 352.0,
    abilities: ["Drizzle", "Primordial Sea"],
    description: "Kyogre is said to be the personification of the sea itself. Legends tell of its many clashes against Groudon, as each sought to gain the power of nature.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Grass", "Electric"],
    typeResistances: ["Fire", "Water", "Ice", "Steel"],
    trivia: [
      "Kyogre is one of the super-ancient Pokémon from Hoenn mythology.",
      "It can expand the sea by bringing heavy rains and massive floods."
    ]
  },
  {
    id: 383,
    name: "Groudon",
    types: ["Ground"],
    region: "Hoenn",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/383.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/383.png",
    stats: {
      hp: 100,
      attack: 150,
      defense: 140,
      "special-attack": 100,
      "special-defense": 90,
      speed: 90
    },
    height: 3.5,
    weight: 950.0,
    abilities: ["Drought", "Desolate Land"],
    description: "Groudon has long been described in mythology as the Pokémon that raised lands and expanded continents. This Pokémon took to sleep after a cataclysmic battle with Kyogre.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Grass", "Ice"],
    typeResistances: ["Poison", "Rock", "Electric (immune)"],
    trivia: [
      "Groudon is said to have expanded the landmass of the world by evaporating water with intense heat.",
      "It is locked in an ancient rivalry with Kyogre."
    ]
  },
  {
    id: 493,
    name: "Arceus",
    types: ["Normal"],
    region: "Sinnoh",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/493.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/493.png",
    stats: {
      hp: 120,
      attack: 120,
      defense: 120,
      "special-attack": 120,
      "special-defense": 120,
      speed: 120
    },
    height: 3.2,
    weight: 320.0,
    abilities: ["Multitype"],
    description: "According to the legends of Sinnoh, this Pokémon emerged from an egg and shaped all there is in this world.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fighting"],
    typeResistances: ["Ghost (immune)"],
    trivia: [
      "Arceus is known as 'The Original One' and is said to have created the Sinnoh region and possibly the entire Pokémon world.",
      "It can change its type when holding different plates, allowing it to be any of the 18 types."
    ]
  },
  {
    id: 718,
    name: "Zygarde",
    types: ["Dragon", "Ground"],
    region: "Kalos",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/718.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/718.png",
    stats: {
      hp: 108,
      attack: 100,
      defense: 121,
      "special-attack": 81,
      "special-defense": 95,
      speed: 95
    },
    height: 5.0,
    weight: 305.0,
    abilities: ["Aura Break", "Power Construct"],
    description: "It's said to be monitoring the ecosystem. There are rumors that even greater power lies hidden within it.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ice (4×)", "Dragon", "Fairy"],
    typeResistances: ["Fire", "Poison", "Rock", "Electric (immune)"],
    trivia: [
      "Zygarde has multiple forms: 10% Forme, 50% Forme, and Complete Forme.",
      "It's composed of many cells and cores that can operate independently."
    ]
  },
  {
    id: 984,
    name: "Great Tusk",
    types: ["Ground", "Fighting"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/984.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/984.png",
    stats: {
      hp: 115,
      attack: 131,
      defense: 131,
      "special-attack": 53,
      "special-defense": 53,
      speed: 87
    },
    height: 2.2,
    weight: 320.0,
    abilities: ["Protosynthesis"],
    description: "This Pokémon resembles Donphan but is far more ancient. It charges at enemies with its thick, heavy tusks, which can easily shatter large boulders.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Grass", "Ice", "Flying", "Psychic", "Fairy"],
    typeResistances: ["Poison", "Rock", "Bug", "Dark", "Electric (immune)"],
    trivia: [
      "Great Tusk is a Paradox Pokémon related to Donphan, from the distant past.",
      "Its tusks are said to be harder than diamond and can pierce through anything."
    ]
  },
  {
    id: 985,
    name: "Scream Tail",
    types: ["Fairy", "Psychic"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/985.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/985.png",
    stats: {
      hp: 115,
      attack: 65,
      defense: 99,
      "special-attack": 65,
      "special-defense": 115,
      speed: 111
    },
    height: 1.2,
    weight: 8.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Jigglypuff. The soundwaves it emits from its tail cause headaches in those who hear them.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Poison", "Ghost", "Steel"],
    typeResistances: ["Fighting", "Psychic", "Dragon (immune)"],
    trivia: [
      "Scream Tail is a Paradox Pokémon related to Jigglypuff, from the distant past.",
      "Its tail can produce ultrasonic waves that can incapacitate foes."
    ]
  },
  {
    id: 986,
    name: "Brute Bonnet",
    types: ["Grass", "Dark"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/986.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/986.png",
    stats: {
      hp: 111,
      attack: 127,
      defense: 99,
      "special-attack": 79,
      "special-defense": 99,
      speed: 55
    },
    height: 1.2,
    weight: 21.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Amoonguss. It stores energy within the mushroom cap on its head, which it can release in a powerful blast.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Flying", "Poison", "Fighting", "Bug", "Fire", "Ice", "Fairy"],
    typeResistances: ["Water", "Electric", "Grass", "Ground", "Ghost", "Dark", "Psychic (immune)"],
    trivia: [
      "Brute Bonnet is a Paradox Pokémon related to Amoonguss, from the distant past.",
      "Unlike modern mushroom Pokémon, it actively hunts prey rather than waiting to ambush them."
    ]
  },
  {
    id: 987,
    name: "Flutter Mane",
    types: ["Ghost", "Fairy"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/987.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/987.png",
    stats: {
      hp: 55,
      attack: 55,
      defense: 55,
      "special-attack": 135,
      "special-defense": 135,
      speed: 135
    },
    height: 1.4,
    weight: 4.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Misdreavus. Its beautiful, flowing hair can extend to ensnare prey, and it feeds on the negative emotions of others.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Ghost", "Steel", "Dark"],
    typeResistances: ["Fighting", "Bug", "Normal (immune)", "Dragon (immune)"],
    trivia: [
      "Flutter Mane is a Paradox Pokémon related to Misdreavus, from the distant past.",
      "Its ethereal hair can change shape and harden at will, becoming sharp enough to cut through steel."
    ]
  },
  {
    id: 988,
    name: "Slither Wing",
    types: ["Bug", "Fighting"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/988.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/988.png",
    stats: {
      hp: 85,
      attack: 135,
      defense: 79,
      "special-attack": 85,
      "special-defense": 105,
      speed: 81
    },
    height: 3.2,
    weight: 92.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Volcarona. It charges at foes with its powerful arms and can slice through boulders with its sharp claws.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fire", "Flying", "Psychic", "Fairy"],
    typeResistances: ["Ground", "Bug", "Grass", "Dark"],
    trivia: [
      "Slither Wing is a Paradox Pokémon related to Volcarona, from the distant past.",
      "Unlike modern Volcarona, it prefers physical combat over special attacks."
    ]
  },
  {
    id: 989,
    name: "Sandy Shocks",
    types: ["Electric", "Ground"],
    region: "Paldea",
    image: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/989.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/989.png",
    stats: {
      hp: 85,
      attack: 81,
      defense: 97,
      "special-attack": 121,
      "special-defense": 85,
      speed: 101
    },
    height: 2.3,
    weight: 60.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Magneton. It can generate powerful electromagnetic fields that allow it to float and manipulate sand and dust in the air.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Grass", "Ice"],
    typeResistances: ["Flying", "Poison", "Bug", "Rock", "Steel", "Fire", "Electric (immune)"],
    trivia: [
      "Sandy Shocks is a Paradox Pokémon related to Magneton, from the distant past.",
      "It can create sandstorms charged with electricity, making them even more dangerous."
    ]
  },
  {
    id: 990,
    name: "Roaring Moon",
    types: ["Dragon", "Dark"],
    region: "Paldea",
    image: "https://archives.bulbagarden.net/media/upload/thumb/6/69/1005Roaring_Moon.png/375px-1005Roaring_Moon.png",
    shinyImage: "https://shinyash.com/cdn/shop/files/1005-Bramaluna-Shiny-6IV-Roaring-Moon-ShinyAsh-3905.png?v=1740273942&width=480",
    stats: {
      hp: 105,
      attack: 139,
      defense: 71,
      "special-attack": 55,
      "special-defense": 101,
      speed: 119
    },
    height: 2.0,
    weight: 380.0,
    abilities: ["Protosynthesis"],
    description: "This ancient Pokémon resembles Salamence. Its roar can cause temporary paralysis, and it hunts by swooping down on prey from great heights.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fairy", "Fighting", "Bug", "Ice", "Dragon"],
    typeResistances: ["Fire", "Water", "Electric", "Grass", "Ghost", "Dark", "Psychic (immune)"],
    trivia: [
      "Roaring Moon is a Paradox Pokémon related to Salamence, from the distant past.",
      "Unlike modern dragons, its scales are reinforced with a metal-like substance, making them incredibly durable."
    ]
  },
  {
    id: 991,
    name: "Iron Bundle",
    types: ["Ice", "Water"],
    region: "Paldea",
    image: "https://www.pokemon.com/static-assets/content-assets/cms2/img/pokedex/full/991.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/991.png",
    stats: {
      hp: 56,
      attack: 80,
      defense: 114,
      "special-attack": 124,
      "special-defense": 60,
      speed: 136
    },
    height: 0.6,
    weight: 11.0,
    abilities: ["Quark Drive"],
    description: "This futuristic Pokémon resembles Delibird. Its body maintains a temperature of -240 degrees Fahrenheit, and it can shoot powerful beams of ice that freeze anything they touch.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Electric", "Fighting", "Rock", "Grass"],
    typeResistances: ["Ice", "Water"],
    trivia: [
      "Iron Bundle is a Paradox Pokémon related to Delibird, from the distant future.",
      "It has developed advanced technology that allows it to control ice and water with incredible precision."
    ]
  },
  {
    id: 994,
    name: "Wo-Chien",
    types: ["Dark", "Grass"],
    region: "Paldea",
    image: "https://archives.bulbagarden.net/media/upload/thumb/9/96/1001Wo-Chien.png/375px-1001Wo-Chien.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/1001.png",
    stats: {
      hp: 85,
      attack: 85,
      defense: 100,
      "special-attack": 95,
      "special-defense": 135,
      speed: 70
    },
    height: 1.5,
    weight: 74.2,
    abilities: ["Tablets of Ruin"],
    description: "Known as the Ruinous Pokémon of Dark, Wo-Chien is said to have brought famine to the lands. Its leaves can drain the life energy of anything they touch.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Flying", "Poison", "Bug", "Fighting", "Fire", "Ice", "Fairy"],
    typeResistances: ["Water", "Electric", "Grass", "Ground", "Ghost", "Dark", "Psychic (immune)"],
    trivia: [
      "Wo-Chien is one of the four Ruinous Pokémon sealed away in shrines across the Paldea region.",
      "It can absorb nutrients from the soil through its roots, allowing it to survive even in barren lands."
    ]
  },
  {
    id: 995,
    name: "Chien-Pao",
    types: ["Dark", "Ice"],
    region: "Paldea",
    image: "https://archives.bulbagarden.net/media/upload/thumb/9/9c/1002Chien-Pao.png/375px-1002Chien-Pao.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/995.png",
    stats: {
      hp: 80,
      attack: 120,
      defense: 80,
      "special-attack": 90,
      "special-defense": 65,
      speed: 135
    },
    height: 1.9,
    weight: 152.2,
    abilities: ["Sword of Ruin"],
    description: "Known as the Ruinous Pokémon of Ice, Chien-Pao brought freezing winds that killed crops and froze entire villages. It moves swiftly through snow and ice.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Fighting", "Rock", "Steel", "Fire", "Bug", "Fairy"],
    typeResistances: ["Ghost", "Ice", "Dark", "Psychic (immune)"],
    trivia: [
      "Chien-Pao is one of the four Ruinous Pokémon sealed away in shrines across the Paldea region.",
      "It's said to be able to freeze its enemies solid with a single breath."
    ]
  },
  {
    id: 996,
    name: "Ting-Lu",
    types: ["Dark", "Ground"],
    region: "Paldea",
    image: "https://archives.bulbagarden.net/media/upload/thumb/e/ec/1003Ting-Lu.png/375px-1003Ting-Lu.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/996.png",
    stats: {
      hp: 155,
      attack: 110,
      defense: 125,
      "special-attack": 55,
      "special-defense": 80,
      speed: 45
    },
    height: 2.7,
    weight: 699.7,
    abilities: ["Vessel of Ruin"],
    description: "Known as the Ruinous Pokémon of Earth, Ting-Lu caused devastating earthquakes that swallowed entire towns. Its heavy steps can make the ground tremble.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Grass", "Ice", "Fighting", "Bug", "Fairy"],
    typeResistances: ["Poison", "Rock", "Ghost", "Dark", "Electric (immune)", "Psychic (immune)"],
    trivia: [
      "Ting-Lu is one of the four Ruinous Pokémon sealed away in shrines across the Paldea region.",
      "The strange growth on its back resembles a pagoda and is said to contain immense power."
    ]
  },
  {
    id: 997,
    name: "Chi-Yu",
    types: ["Dark", "Fire"],
    region: "Paldea",
    image: "https://archives.bulbagarden.net/media/upload/thumb/c/c1/1004Chi-Yu.png/375px-1004Chi-Yu.png",
    shinyImage: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/shiny/997.png",
    stats: {
      hp: 55,
      attack: 80,
      defense: 80,
      "special-attack": 135,
      "special-defense": 120,
      speed: 100
    },
    height: 0.4,
    weight: 4.9,
    abilities: ["Beads of Ruin"],
    description: "Known as the Ruinous Pokémon of Fire, Chi-Yu brought scorching flames that reduced entire forests and villages to ash. Its body temperature can melt steel.",
    legendary: true,
    evolutions: [],
    typeWeaknesses: ["Water", "Ground", "Rock", "Fighting"],
    typeResistances: ["Ghost", "Steel", "Fire", "Grass", "Ice", "Dark", "Psychic (immune)"],
    trivia: [
      "Chi-Yu is one of the four Ruinous Pokémon sealed away in shrines across the Paldea region.",
      "Despite its small size, it's capable of producing flames hot enough to vaporize water instantly."
    ]
  },
];